




































import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

@Component
export default class Dialog extends Vue {
  @Prop({default: false}) private open!: boolean;
  @Prop({default: false}) private eagerLoading!: boolean;
  @Prop({default: '40vw'}) private maxWidth!: string;
  @Prop() private width!: string;
  @Prop({default: false}) private persistent!: boolean;
  @Prop({default: ''}) private overrideHeightClass!: string;
  @Prop({default: false}) private loading!: boolean;
  @Prop({default: null}) private type!: string | null;
}
